const ITEMS = [
  'Professionals, Families & Trusted Guests',
  'Guaranteed Rent Every Month',
  'Professional Cleaning Several Times a Week',
  '3–5+ Year Agreements',
  'Premium Property Uplift Included',
  'Complete Hands-Off Management',
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-[#DCBC7F]/15 bg-[#1B6640] py-5" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="mono-label whitespace-nowrap px-8 text-[#C4D4C9]">{item}</span>
                <span className="h-1 w-1 rotate-45 bg-[#DCBC7F]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
